import Auth from "@aws-amplify/auth";
import { FederatedSignInOptions } from "@aws-amplify/auth/src/types/Auth";
import { Hub } from "@aws-amplify/core";
import EmblaCarousel from "embla-carousel";
import EmblaCarouselAutoplay from "embla-carousel-autoplay";

import * as $ from "jquery";
import * as _ from "lodash";
import { Utils } from "../common/utils";
import { BaseBrandedView } from "./_BaseViews";

declare var CONFIG;
declare var App;

var emailId = "#login-input-username";
var passwordId = "#login-input-password";

let embla;

enum LoginStep {
    EmailVisible,
    PasswordVisible,
}

export class LoginView extends BaseBrandedView {
    private template = _.template(require("templates/login.html"));
    private loading = false;
    private ssoProps = null;
    private ssoProvider = null;
    private firstRender = true;

    constructor(options) {
        super(
            <any>_.extend(options, {
                tagName: "div",
                events: {
                    "input #login-input-username": "handleEmailInput",
                    "submit .login-form": "handleLoginSubmit",
                    "click #login-federated-button": "handleFederatedLogin",
                },
            })
        );

        Hub.listen("auth", (data) => {
            if (data && data.payload.event === "signIn_failure") {
                this.loading = false;
            } else {
                this.loading = true;
            }
            this.firstRender = true;
            console.log("called render in hub.listen");
            this.render();
        });

        if (!sessionStorage.getItem("loginNextView")) {
            sessionStorage.setItem("loginNextView", window.location.hash);
        }

        $(".navbar").hide();
        $(".footer").hide();
    }

    private validateForm() {
        var errors = [];

        var emailVisible = this.$(emailId).is(":visible");
        if (emailVisible) {
            var email = Utils.isValidEmail(String(this.$(emailId).val()));
            if (!email) {
                errors.push("Please enter a valid email address");
            }
        }

        var passwordVisible = this.$(passwordId).is(":visible");
        if (passwordVisible) {
            var password = String(this.$(passwordId).val()).trim();
            if (!password) {
                errors.push("Please enter a valid password");
            }
        }
        return errors;
    }

    private setUIStep(step: LoginStep) {
        var step1 = step === LoginStep.EmailVisible;

        // Change form visibilities
        var brand = this.options.brandCollection.getBrand();
        var showSSOLogin = !brand.get("is_default") && brand.get("sso_idp");
        this.$(".federated-form-group").toggleClass("hidden", !showSSOLogin);
        if (showSSOLogin) this.setSSOProvider(brand.get("sso_idp"), brand.get("sso_idp_type"));

        this.$(".password-form-group").toggleClass("hidden", step1);
        this.$(".submit-form-group").toggleClass("hidden", step1);
        this.$(".next-form-group").toggleClass("hidden", !step1);

        if (!this.ssoProps) return;
        // if the user is specifically an SSO user
        var showOnlySSOLogin = this.ssoProps.is_sso_user || this.ssoProps.is_sso_domain;
        showSSOLogin = showSSOLogin || showOnlySSOLogin;
        this.$(".federated-form-group").toggleClass("hidden", !showSSOLogin);
        this.$(".password-form-group").toggleClass("hidden", showOnlySSOLogin || step1);
        this.$(".submit-form-group").toggleClass("hidden", showOnlySSOLogin || step1);
        this.$(".next-form-group").toggleClass("hidden", showOnlySSOLogin || !step1);

        if (this.ssoProps.sso_idp) this.setSSOProvider(this.ssoProps.sso_idp, this.ssoProps.sso_idp_type);
    }

    private setSSOProvider(provider, providerType) {
        this.ssoProvider = provider;
        this.$("#login-federated-button").addClass(providerType);
        this.$("#login-federated-button img").attr("src", require(`../../img/sso/${providerType}.png`));
        this.$("#login-federated-button .provider-name").text(
            providerType === "Corporate" ? "Corporate Account" : providerType
        );
    }

    private handleEmailInput() {
        this.ssoProps = null;
        this.setUIStep(LoginStep.EmailVisible);
    }

    private getEmail() {
        return this.$(emailId).val().toString().trim().toLowerCase();
    }

    private handleLoginSubmit(e) {
        e.preventDefault();
        sessionStorage.setItem("loginSSOError", "");

        var emailVisible = this.$(emailId).is(":visible");
        var passwordVisible = this.$(passwordId).is(":visible");
        var federatedVisible = this.$("#login-federated-button").is(":visible");
        var nextVisible = this.$(".next-form-group").is(":visible");

        if (federatedVisible && !passwordVisible && !nextVisible) {
            this.handleFederatedLogin();
        } else if (emailVisible && !passwordVisible) {
            var email = this.getEmail();
            var errors = this.validateForm();
            if (errors.length) return this.render(errors);

            $.when(this.getSSOProps(email)).then((response) => {
                this.ssoProps = response;
                this.render([], LoginStep.PasswordVisible);
            });
        } else {
            this.handleSignIn();
        }
    }

    private getSSOProps(email) {
        return $.ajax({
            type: "GET",
            url: window.location.origin + "/sso_props?q=" + encodeURIComponent(email),
            dataType: "json",
            contentType: "application/json; charset=utf-8",
        });
    }

    private handleFederatedLogin() {
        // we want to keep recent visits to dashboard and reports
        const savedRecentDashboards = localStorage.getItem("recentDashboards");
        const savedRecentReports = localStorage.getItem("recentReports");

        localStorage.clear();

        // re-save recent visits to dashboard and reports
        if (savedRecentDashboards) localStorage.setItem("recentDashboards", savedRecentDashboards);
        if (savedRecentReports) localStorage.setItem("recentReports", savedRecentReports);

        Auth.federatedSignIn(<FederatedSignInOptions>{ provider: this.ssoProvider });
    }

    private handleSignIn() {
        var errors = this.validateForm();
        if (errors.length) return this.render(errors);

        var email = this.getEmail();
        var password = this.$(passwordId).val();
        this.performSignIn(email, password);
        this.loading = true;
        console.log("called render in handlesigin");
        this.render();
    }

    private performSignIn(email, password) {
        // we want to keep recent visits to dashboard and reports
        const savedRecentDashboards = localStorage.getItem("recentDashboards");
        const savedRecentReports = localStorage.getItem("recentReports");

        localStorage.clear();

        // re-save recent visits to dashboard and reports
        if (savedRecentDashboards) localStorage.setItem("recentDashboards", savedRecentDashboards);
        if (savedRecentReports) localStorage.setItem("recentReports", savedRecentReports);
        
        // See https://aws-amplify.github.io/docs/js/authentication
        Auth.signIn(email as string, password as string)
            .then((user) => {
                if (user.challengeName === "SMS_MFA" || user.challengeName === "SOFTWARE_TOKEN_MFA") {
                    // TODO: Need to support once we enable MFA
                } else if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                    // We currently don't support this, but this should never happen
                    this.render(["NEW_PASSWORD_REQUIRED"]);
                } else if (user.challengeName === "MFA_SETUP") {
                    // TODO: Need to support once we enable MFA
                } else {
                    // Sign in succesful
                    this.loading = true;
                    this.render();

                    App.waitForIdToken().then((token) => {
                        window.location.reload();
                    });
                }
            })
            .catch((err) => {
                if (err.code === "UserNotConfirmedException") {
                    // The error happens if the user didn't finish the confirmation step when signing up
                    // In this case you need to resend the code and confirm the user
                    // About how to resend the code and confirm the user, please check the signUp part
                    console.log("PasswordResetRequiredException");
                } else if (err.code === "PasswordResetRequiredException") {
                    // The error happens when the password is reset in the Cognito console
                    // In this case you need to call forgotPassword to reset the password
                    // Please check the Forgot Password part.
                    console.log("PasswordResetRequiredException");
                } else if (err.code === "NotAuthorizedException" || err.code === "UserNotFoundException") {
                    // The error happens when the incorrect password is provided
                    // or when the supplied username/email does not exist in the Cognito user pool

                    // Try to log in to the old backend in case we have to migrate the user
                    this.migrateUser(email, password);
                } else {
                    console.log(err);
                }
            });
    }

    private migrateUser(email, password) {
        $.ajax({
            type: "POST",
            url: window.location.origin + "/login",
            contentType: "application/x-www-form-urlencoded",
            dataType: "json",
            data: { email, password },
            success: (response) => {
                if (response.code === "RETRY") {
                    return this.performSignIn(email, password);
                }
                window.location.hash = `authmigrate/${response.user_id}/${response.token}`;
            },
            error: (jqXHR) => {
                this.loading = false;
                this.render(["Incorrect Email Address or Password. Please try again."]);
                this.$(emailId).val(email);
            },
        });
    }

    render(errors?: string[], nextStep?: LoginStep) {
        var err = errors ? errors : [];
        if (err.length) {
            $(passwordId).val("");
            for (const error of err) {
                (<any>$).notify(
                    {
                        title: "Something went wrong",
                        message: error,
                        icon: "fa fa-exclamation-circle",
                    },
                    {
                        animate: {
                            enter: "animated fadeInUp",
                        },
                        // The type property defines the css style
                        // See alerts.less for available styles
                        type: `warning-alt`,
                        placement: { from: "bottom", align: "center" },
                        delay: 4000,
                    }
                );
            }
            this.loading = false;
        }

        var ssoError = sessionStorage.getItem("loginSSOError");
        if (ssoError) err.push(ssoError);

        if (!nextStep) nextStep = LoginStep.EmailVisible;

        const brand = this.options.brandCollection.getBrand();
        // Temporary solution for supporting white-label functionality,
        // we need to hide the sign-in carousel for a specific brand (Poppy)
        const brandOrigin = brand.get("origin") ?? "";
        const hideCarousel = brandOrigin === "https://iaq.poppy.com";
        if (this.firstRender) {
            this.$el.html(
                this.template({
                    loading: this.loading,
                    brand: brand,
                    errors: err,
                    username: $(emailId).val(),
                    password: $(passwordId).val(),
                    hideCarousel: hideCarousel,
                })
            );

            // Call the function to initialize the Embla carousel after rendering
            this.recreateCarousel();
        }

        setTimeout(() => {
            var emailVisible = this.$(emailId).is(":visible");
            var passwordVisible = this.$(passwordId).is(":visible");
            if (passwordVisible) {
                this.$(passwordId).focus();
            } else if (emailVisible) {
                this.$(emailId).focus();
            }
        }, 500);
        this.setUIStep(nextStep);

        this.firstRender = false;

        return this;
    }

    initCarousel() {
        const emblaNode = this.$(".embla").get(0); // Get the main carousel node
        const prevButton = this.$(".embla__button--prev").get(0); // Get the previous button
        const nextButton = this.$(".embla__button--next").get(0); // Get the next button
        const dotsContainer = this.$(".embla__dots").get(0); // Get the dots container

        // Initialize Embla with Autoplay plugin
        embla = EmblaCarousel(emblaNode, { loop: true }, [
            EmblaCarouselAutoplay({ delay: 6000 }), // Autoplay delay of 6 seconds
        ]);

        // Create dots for the carousel slides
        const createDots = () => {
            dotsContainer.innerHTML = ""; // Clear previous dots before creating new ones
            const slideCount = embla.slideNodes().length; // Get the number of slides
            for (let i = 0; i < slideCount; i++) {
                const dot = document.createElement("button");
                dot.classList.add("embla__dot");
                dot.setAttribute("role", "tab");
                dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
                dotsContainer.appendChild(dot);

                // Add click event for each dot
                dot.addEventListener("click", () => embla.scrollTo(i));
            }
        };

        // Update the active dot when the slide changes
        const updateActiveDot = () => {
            const allDots = this.$(".embla__dot");
            allDots.each((index, dot) => {
                const isActive = embla.selectedScrollSnap() === index;
                $(dot).toggleClass("embla__dot--active", isActive);
                $(dot).attr("aria-selected", isActive.toString()); // Convert boolean to string
            });
        };

        // Initialize the dots and update the first active one
        createDots();
        updateActiveDot();

        // Add click events to navigate through slides
        prevButton.addEventListener("click", () => embla.scrollPrev());
        nextButton.addEventListener("click", () => embla.scrollNext());

        // Listen for Embla events to update the active dot
        embla.on("select", updateActiveDot);
    }

    // Function to destroy the carousel
    destroyCarousel() {
        if (embla) {
            embla.destroy();
            embla = null;
        }
    }

    // Function to recreate the carousel (destroy first, then reinit)
    recreateCarousel() {
        this.destroyCarousel();
        this.initCarousel();
    }

    remove() {
        // Ensure the top bar and footer are visible again when this view is removed
        $(".navbar").show();
        $(".footer").show();

        return super.remove();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/LoginView.ts